import React from 'react';

import Avatar from '../../../Avatar';
import Layout from '../../../Layout';
import BaseCell from '../BaseCell';
import { TextCell, TextCellProps } from '../CellPatterns';

const CLIENT_AVATAR_SIZE = 24;

export interface ClientCellClient {
  id: number;
  name: string;
  logo_url?: string | null;
  logoUrl?: string | null;
}

interface Props extends Pick<TextCellProps, 'align' | 'href'> {
  /** Client/customer/organization to display. When null, renders "—". */
  client: ClientCellClient | null;
}

const ClientCell: React.FC<Props> = ({ client, href, align }) => {
  if (client === null || client === undefined) {
    return <TextCell value={null} avatarUrl={null} align={align} href={href} />;
  }

  const logoUrl = client.logo_url ?? client.logoUrl ?? null;
  const hasLogo = logoUrl != null && logoUrl !== '';

  const leadingContent = (
    <Avatar
      size={CLIENT_AVATAR_SIZE}
      avatarUrl={hasLogo ? (logoUrl ?? undefined) : undefined}
      borderWidth={0}
      defaultIcon="buildingNew"
      defaultIconColor="gray-200"
      backgroundColor="gray-25"
    />
  );

  return (
    <Layout padding={0} width="100%" flexShrink={0}>
      <BaseCell value={client.name} leadingContent={leadingContent} href={href} align={align} />
    </Layout>
  );
};

export default ClientCell;
